import { motion } from "framer-motion";
import { Link } from "react-scroll";

const HERO_IMAGE = "/hero.png";

const fadeUp = {
  hidden: { opacity: 0, y: 32 },
  show: (delay = 0) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.85, ease: [0.22, 1, 0.36, 1], delay },
  }),
};

const lineReveal = {
  hidden: { scaleX: 0 },
  show: {
    scaleX: 1,
    transition: { duration: 1.1, ease: [0.22, 1, 0.36, 1], delay: 0.5 },
  },
};

export default function Hero() {
  return (
    <section
      id="hero"
      className="relative min-h-screen flex items-center justify-center overflow-hidden"
    >
      <div className="absolute inset-0 z-0">
        <img
          src={HERO_IMAGE}
          alt="Premium black car service"
          className="w-full h-full object-contain md:object-cover md:object-center"
          style={{ background: "#0a0a0a" }}
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/75 via-black/55 to-black/85" />
        <div className="absolute inset-0 bg-gradient-to-r from-black/40 via-transparent to-black/40" />
      </div>

      <div className="relative z-10 max-w-5xl mx-auto px-5 md:px-8 text-center pt-20">
        <motion.p
          className="text-gold tracking-[0.35em] text-xs md:text-sm uppercase mb-6 font-medium"
          initial="hidden"
          animate="show"
          custom={0}
          variants={fadeUp}
        >
          St. Louis Premier Black Car Service
        </motion.p>

        <motion.h1
          className="font-display text-4xl sm:text-5xl md:text-6xl lg:text-7xl text-cream font-semibold leading-[1.08] mb-5"
          initial="hidden"
          animate="show"
          custom={0.18}
          variants={fadeUp}
        >
          Premium Black Car Service
          <br />
          <span className="italic font-normal">in St. Louis</span>
        </motion.h1>

        <motion.div
          className="h-px bg-gold mx-auto mb-8 origin-center"
          style={{ width: "80px" }}
          initial="hidden"
          animate="show"
          variants={lineReveal}
        />

        <motion.p
          className="text-cream/70 text-base md:text-lg lg:text-xl max-w-2xl mx-auto leading-relaxed mb-10 font-light"
          initial="hidden"
          animate="show"
          custom={0.4}
          variants={fadeUp}
        >
          Professional chauffeurs. Mercedes-Benz, Cadillac Escalade, and Genesis
          fleet. Available 24/7.
        </motion.p>

        <motion.div
          className="flex flex-col sm:flex-row items-center justify-center gap-4"
          initial="hidden"
          animate="show"
          custom={0.55}
          variants={fadeUp}
        >
          <Link to="booking" smooth duration={700} offset={-112}>
            <button className="btn-gold min-w-[200px]">Book Your Ride</button>
          </Link>
          <a href="tel:+13146650983">
            <button className="btn-outline-gold min-w-[200px]">
              Call Us — 314-665-0983
            </button>
          </a>
        </motion.div>

        <motion.div
          className="absolute bottom-4 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 opacity-50 z-0 hidden md:flex"
          initial={{ opacity: 0 }}
          animate={{ opacity: 0.5 }}
          transition={{ delay: 1.4, duration: 0.8 }}
        >
          <span className="text-cream text-xs tracking-widest uppercase">
            Scroll
          </span>
          <motion.div
            className="w-px h-8 bg-gold origin-top"
            animate={{ scaleY: [0, 1, 0] }}
            transition={{ duration: 1.6, repeat: Infinity, ease: "easeInOut" }}
          />
        </motion.div>
      </div>
    </section>
  );
}
